import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type SessionContextService from 'tio-employee/services/session-context';

/**
 * `authenticated` is mounted at `/` and has no index template, so anything that
 * lands here renders the app shell around an empty outlet — a blank page.
 *
 * The parent route already redirects off the index, but only from its
 * `beforeModel`, which does not re-run once `authenticated` is active. So a
 * guard elsewhere in the tree doing `replaceWith('authenticated')` dead-ends.
 * This closes that off at the index itself, wherever the transition came from.
 */
export default class AuthenticatedIndexRoute extends Route {
  @service declare router: RouterService;
  @service declare sessionContext: SessionContextService;

  beforeModel() {
    this.router.replaceWith(this.sessionContext.landingRoute);
  }
}
